<template>
  <div class="widget border-0">
    <div class="header">
      <div class="title">
        {{ title }}
        <div class="d-flex float-right">
          <span
            class="circle"
            :style="'background: ' + background[1]"
          /><span class="label ml-1">{{ __('Negócios') }}</span><span class="circle ml-2" /><span class="label ml-1">{{ __('Valor') }}</span>
        </div>
      </div>
    </div>
    <div
      class="body mt-4"
      v-if="loading"
    >
      <span class="loading"><i class="fa fa-circle-o-notch fa-spin" /></span>
    </div>
    <div
      class="body mt-4"
      v-else
    >
      <div v-if="show">
        <ChartRoundedHorizontalBarChart
          class="chart"
          :id="id"
          :background="background"
          :chart-data="chartData"
          :options="options"
          :plugin="plugin"
        />
      </div>
      <div
        class="empty"
        v-else
      >
        <h2>{{ __('Nenhum dado foi encontrado neste período!') }}</h2>
        <h3>{{ __('Já tentou alterar as datas?') }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import progressWidget from '../../mixins/progress-widget';
import chartDeal from '../../mixins/chartDeal';

export default {
  mixins: [
    progressWidget,
    chartDeal,
  ],

  props: ['name', 'id'],

  computed: {
    title () {
      const {
        __,
      } = this;

      const title = {
        'deal.progress': __('Progresso de negócios'),
        'deal.started': __('Negócios iniciados'),
        'deal.lost': __('Negócios perdidos'),
        'deal.won': __('Negócios ganhos'),
      };

      return title[this.name];
    },

    background () {
      const background = {
        'deal.progress': ['#FF7F00', '#FF7F00'],
        'deal.started': ['#886AF8', '#886AF8'],
        'deal.lost': ['#FF2E56', '#FF2E56'],
        'deal.won': ['#2CEBA9', '#2CEBA9'],
      };

      return background[this.name];
    },
  },
};
</script>

<style lang="scss" scoped>
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .label {
      line-height: 90% !important;
    }
  }
</style>
